<script setup>
import { inject, computed, ref, onMounted, onBeforeUnmount } from 'vue';
import { usePortAllData } from '@/stores/portAllData';
import { storeToRefs } from 'pinia';
import { authorizedModule } from '@/plugins/utils/Authorization.js';
import ModuleButton from './ModuleButton.vue';
import ModulePalette from './ModulePalette.vue';
import { OPEN_MODULE_EVENT } from '@/plugins/utils/events.js';

const store = usePortAllData();
const { getAuthConfig, getModuleProcessing, getIsMobile } = storeToRefs(store);
const { setModuleOpen } = store;
const $config = inject('$config');
const $map = inject('$map');
const modules = $config.modules;
const activeModule = ref(null);

const props = defineProps({
  showDraught: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['update:showDraught']);

onMounted(() => {
  document.addEventListener(OPEN_MODULE_EVENT, openModuleEvent)
})

onBeforeUnmount(() => {
  document.removeEventListener(OPEN_MODULE_EVENT, openModuleEvent)
})

const openModuleEvent = (e) => {
  clickEvent(e.detail.module)
}

const isAuthorized = (key) => {
  return authorizedModule(key, getAuthConfig.value.authorizedModules)
}

const moduleParams = computed(() => {
  const params = [];
  for (const [key, value] of Object.entries(modules)) {
    // if (value && isAuthorized(key)) {
    if (value && isAuthorized(key) && (getIsMobile.value ? value.mobile : true)) {
      params.push({
        ...value,
        module: key
      })
    }
  }
  params.sort(sortModules)
  return params;
});

const sortModules = (a, b) => {
  if (a.sort > b.sort) return 1
  if (b.sort > a.sort) return -1
  return 0
}

const selectedModule = computed(() => {
  if (activeModule.value) {
    const module = moduleParams.value.find(m => m.module === activeModule.value)
    return module;
  } else {
    return {};
  }
});

const showPalette = computed(() => {
  return Object.entries(selectedModule.value).length > 0
});

const paletteVisibilityClass = 'ol-geomod-palette-visible';

const clickEvent = (e) => {
  activeModule.value = e;
  if (activeModule.value) {
    $map.addStyleOnControlLayer(paletteVisibilityClass);
    setModuleOpen(true);
    if (e === 'ulhysses') emit('update:showDraught', false)
    else emit('update:showDraught', true)
  } else {
    $map.removeStyleOnControlLayer(paletteVisibilityClass);
    setModuleOpen(false);
    if (!props.showDraught) emit('update:showDraught', true)
  }
}

</script>

<template>
  <div class="geomod-module">
    <div class="geomod-module-bar">
      <module-button
        v-for="(param, index) of moduleParams"
        :key="index"
        :module-param="param"
        :is-active="param.module === activeModule"
        :is-processing="getModuleProcessing[param.code]"
        @click="clickEvent"
      />
    </div>
    <module-palette :module-param="selectedModule" :class="{ shown: showPalette }" />
  </div>
</template>